import { MantineThemeOverride } from '@mantine/core';

export type BoxTheme = NonNullable<MantineThemeOverride['components']>['Box'];

export const Box: BoxTheme = {
  // todo: define
};
